export default __webpack_public_path__ + "static/labs-720b9472c15cb8fdeec262afdcc7ac73.svg";